export default {
  variableRegex: /{[A-Za-z0-9]+}/gm,
  isVariable (text) {
    return this.findAllVariables(text).length > 0
  },
  findAllVariables (text) {
    return String(text).match(this.variableRegex) || []
  },
  getInvalidVariablesInFields (availableVariables, fields) {
    const invalidVariables = []
    fields.forEach(field => {
      invalidVariables.push(...this.getInvalidVariables(availableVariables, field))
    })
    return invalidVariables
  },
  getInvalidVariables (availableVariables, text) {
    const variables = this.findAllVariables(text)
    const invalidVariables = []
    variables.forEach(variable => {
      if (!availableVariables.includes(variable)) invalidVariables.push(variable)
    })
    return invalidVariables
  }
}
